import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utills/axiosInstance";
import "./OffboardingForm.css";

const OffboardingForm = () => {
	const navigate = useNavigate();

	const [formData, setFormData] = useState({
		reasonForLeaving: "",
		otherReason: "",
		lastWorkingDay: "",
		noticePeriodServed: true,
		handoverDetails: "",
		assetsReturned: false,
		exitInterviewNotes: "",
	});

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData(prev => ({
			...prev,
			[name]: type === "checkbox" ? checked : value
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!formData.reasonForLeaving) {
			alert("Please select a reason for leaving");
			return;
		}
		if (!formData.lastWorkingDay) {
			alert("Last working day is required");
			return;
		}

		try {
			await axiosInstance.post(`/api/submit`, formData);
			alert("Offboarding request submitted successfully!");
			navigate("/employee/dashboard");
		} catch (err) {
			alert(err.response?.data?.msg || "Failed to submit request");
		}
	};

	const handleCancel = () => {
		navigate("/dashboard");
	};

	return (
		<>
			<div className="app-container">
				<div className="header-section">
					<h2 className="page-title">Employee Offboarding Request</h2>
				</div>

				<form className="upload-form" onSubmit={handleSubmit}>

					<div className="form-container">
						<section className="form-section">
							<h3 className="section-title">Offboarding Details</h3>
							<div className="form-grid">
								<div className="form-group">
									<label className="form-label">Reason for Leaving <span className="required">*</span></label>
									<select
										name="reasonForLeaving"
										value={formData.reasonForLeaving}
										onChange={handleChange}
										className="form-control"
										required
									>
										<option value="">Select Reason</option>
										<option value="Resignation">Resignation</option>
										<option value="Termination">Termination</option>
										<option value="Retirement">Retirement</option>
										<option value="End of Contract">End of Contract</option>
										<option value="Others">Others</option>
									</select>
								</div>

								{formData.reasonForLeaving === "Others" && (
									<div className="form-group full-width">
										<label className="form-label">Please Specify</label>
										<input
											type="text"
											name="otherReason"
											value={formData.otherReason}
											onChange={handleChange}
											className="form-control"
											placeholder="Enter reason..."
										/>
									</div>
								)}

								<div className="form-group">
									<label className="form-label">Last Working Day <span className="required">*</span></label>
									<input
										type="date"
										name="lastWorkingDay"
										value={formData.lastWorkingDay}
										onChange={handleChange}
										min={new Date().toISOString().split("T")[0]}
										className="form-control"
										required
									/>
								</div>

								<div className="form-group">
									<label className="form-label">Notice Period Served?</label>
									<div style={{ display: "flex", gap: "20px", marginTop: "8px" }}>
										<label>
											<input
												type="radio"
												name="noticePeriodServed"
												checked={formData.noticePeriodServed === true}
												onChange={() => setFormData(prev => ({ ...prev, noticePeriodServed: true }))}
											/> Yes
										</label>
										<label>
											<input
												type="radio"
												name="noticePeriodServed"
												checked={formData.noticePeriodServed === false}
												onChange={() => setFormData(prev => ({ ...prev, noticePeriodServed: false }))}
											/> No (Short Notice)
										</label>
									</div>
								</div>

								<div className="form-group full-width">
									<label className="form-label">Handover Details / Pending Tasks</label>
									<textarea
										name="handoverDetails"
										value={formData.handoverDetails}
										onChange={handleChange}
										rows="5"
										className="form-control"
										placeholder="List projects, tasks, access details, documentation handed over..."
									/>
								</div>

								<div className="form-group full-width">
									<label className="form-label">Exit Feedback (Optional)</label>
									<textarea
										name="exitInterviewNotes"
										value={formData.exitInterviewNotes}
										onChange={handleChange}
										rows="4"
										className="form-control"
										placeholder="Share your experience, suggestions for improvement..."
									/>
								</div>

								<div className="form-group">
									<label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
										<input
											type="checkbox"
											name="assetsReturned"
											checked={formData.assetsReturned}
											onChange={handleChange}
										/>
										<span>I have returned all company assets (Laptop, ID Card, Access Cards, etc.)</span>
									</label>
								</div>
							</div>
						</section>

						<section className="form-section" style={{ backgroundColor: "#f8f9fa", borderLeft: "4px solid #e74c3c" }}>
							<h3 className="section-title" style={{ color: "#e74c3c" }}>Final Confirmation</h3>
							<p style={{ color: "#555", lineHeight: "1.6" }}>
								By submitting this form, I confirm that:
								<ul style={{ margin: "10px 0", paddingLeft: "20px" }}>
									<li>All assigned work has been completed or properly handed over</li>
									<li>All company property has been returned or will be returned by the last working day</li>
									<li>I understand this action is irreversible once approved</li>
								</ul>
							</p>
							<label style={{ display: "flex", alignItems: "center", gap: "10px", fontWeight: "500", color: "#2c3e50" }}>
								<input type="checkbox" required />
								<span>I have read and agree to the above terms</span>
							</label>
						</section>
					</div>
					
					<div className="action-buttons">
						<button type="submit" className="btn btn-primary">
							Submit Request
						</button>
						<button type="button" className="btn btn-secondary" onClick={handleCancel}>
							Cancel
						</button>
					</div>
				</form>
			</div>
		</>
	);
};

export default OffboardingForm;
